import api from './base';
import { GetListType } from './types/GetListType';

class CfgHwEventsApi {
  public getCfgHwEvents = async (params?: any) => {
    const response = await api.get(`/cfg-hw-events`, {
      params: { ...params, DisplayEvent: true },
    });

    return response.data.data;
  };
}

export default new CfgHwEventsApi();
